var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-notification',{attrs:{"title":'מעולה, אין לנו עוד שאלות.',"text":'אנחנו נעדכן את התזרים בהתאם ונעדכן אותך ב-WhatsApp ברגע שיהיה מוכן.',"notification-buttons":[
                      {
                        title:'הבנתי, תודה!',
                        variant: 'primary',
                        action: _vm.onClose,
                      } ],"icon-type":'warning'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b237a27","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/notification/notification-types/ProcessingAnswers.vue
// module id = null
// module chunks = 